export default {
  improvementplans: {
    title: 'Plan de mejora',
    high: 'Alto',
    middle: 'Medio',
    low: 'Bajo',
    exceed: 'Excedido',
    policy: 'Política',
    measure: 'Acción',
    result: 'Resultado',
    currently_supporting: 'En progreso',
    completion: 'Completado',
    ended: 'Incompleto',
    risk: 'Riesgo',
    thema: "@:{'common.esg.category'}",
    improvement_plan: 'Plan de mejora',
    deadline_for_completion: 'Fecha límite',
    message_count: 'Mensaje',
    operation: 'Operación',
    detail: "@:{'common.scorecard.detail'}",
    indicator: 'Indicador',
    indicator_point: 'Consejo',
    buyer_indicator_point: 'Comentario de la evaluación',
    status: 'Estado',
    supported: 'Completado',
    unsupported: 'No acción',
    progress: 'Estado',
    advice: {
      text_line_1: '',
      text_line_2: 'Empecemos a mejorar su rendimiento ESG a partir de esta evaluación.',
      text_line_3: 'Marque el consejo de establecer objetivos o fecha límite, ',
      text_line_4: 'desde "Crear plan de mejora".',
      text_line_5: 'El progreso puede comprobarse en el gráfico de la izquierda.',
      text_line_6: 'Póngase en ',
      contact: 'Contacto ',
      please_contact_us: 'con nosotros si desea solicitar una reevaluación.',
    },
    sub_section_title_1: 'Plan de mejora en progreso',
    no_data_display: 'No hay datos disponibles',
    sub_section_title_2: 'Consejo incompleto',
    buyer_sub_section_title_2: 'Comentario de la evaluación no completada',
    operation_link_text: 'Crear plan de mejora',
    add_advice: 'Agregar consejo',
    sub_section_title_3: 'Consejo completado',
    buyer_sub_section_title_3: 'Comentario de la evaluación completada',
    revaluation_request: 'Solicite una reevaluación',
    cautionary_note: '¿Le gustaría solicitar una reevaluación basada en su plan de mejora completado?',
    asterisked_text: 'Si desea solicitar una reevaluación, hágalo desde el formulario de contacto.',
    submit_btn_text: 'Solicite una reevaluación',
    table_state: 'tableState',
    select_a_file: 'Selecciona un archivo',
    attached_file: 'Adjuntar archivo',
    notes: 'Nota',
    created_improvement_plan: 'Se creó un plan de mejora',
    error_file_upload: 'Hubo un error al cargar el archivo',
    failed_to_create: 'No se ha creado un plan de mejora. Intenta actualizar la página.',
    no_data_found: 'No se han encontrado datos para la mejora.',
    file_upload: {
      filesize_max: 'Seleccione archivos menores a 10MB.',
      max_files: 'Puede cargar hasta 10 archivos.',
      confirmation_of_deletion: '¿Desea eliminar este archivo?',
    },
    create_improvement_plan: 'Crear plan de mejora',
    no_data_improvement_plan: 'Actualmente no hay planes de mejora.',
  },
  buyer_improvementplans: {
    flag: 'Bandera',
    memo: 'Notas',
    flag_on: 'Establecer una bandera',
    flag_off: 'Retirar una bandera',
    panel: {
      title: 'Información de la empresa/Notas',
      company_memo: 'Notas de la empresa',
      latest_memo: 'Última nota',
      no_memo: 'Aún no hay notas.',
      check_list: 'Lista de verificación',
      memo_list: 'Lista de notas',
      // no_assignee: "",
      assignee_select_box: {
        // assignee: "",
        // placeholder: "",
        // create_member: "",
      },
      create_member_modal: {
        // title: "",
        // label: "",
        // place_holder: "",
      },
      delete_member_modal: {
        // title: "",
        // confirm_text: "",
        delete_button_label: "@:{'improvement_plans_detail.chat.delete_confirm.delete_button_label'}",
      },
    },
    back_to_list: 'Volver a la lista',
    action_cases: 'Casos',
    no_improvements: 'No hay ninguna área de mejora sugerida',
    confirm_delete_memo: '¿Seguro que desea eliminar esta nota?',
    confirm_delete_memo_title: 'Eliminar una nota',
    // display_only_is_marked: "",
    create_memo: 'Crear una nota',
  },
  improvement_plans_detail: {
    create_form: {
      cautions_title: '@:settings.cautions_title',
    },
  },
}
